import { useConvexQuery } from 'convex-vue'
import { api } from '@/convex'

export function usePendingBookingCount() {
  return useConvexQuery(api.bookings.endpoints.countPendingForCurrentProfile, {})
}
